import request from "../utils/request";

/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-19 18:47:29
 * @LastEditTime: 2022-01-21 21:47:11
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/services/wechatServices.js
 */

/**
 * 获取顾问列表
 *
 * @export
 * @param {-} data
 * @returns Promise
 */
export function fetchWechatServicesSalesList(data) {
    return request({
        url: '/platform/wxkf/getGuideAcctList',
        method: 'post',
        data
    })
}

/**
 * 获取顾问的客户列表
 *
 * @export
 * @param {-} data
 * @returns Promise
 */
export function fetchWechatServicesCustomerList(data) {
    return request({
        url: '/platform/wxkf/getGuideBuyerRelationList',
        method: 'post',
        data
    })
}

/**
 * 获取顾问下拉列表
 *
 * @export
 * @param {-} data
 * @returns Promise
 */
export function fetchWechatServicesSalesAllList(data) {
    return request({
        url: '/platform/wxkf/getGuideAcctListAll',
        method: 'post',
        data
    })
}

/**
 * 获取顾问的聊天记录
 *
 * @export
 * @param {{current:0, pageSize: 0, guideAccount:string, guideOpenId: string, openId: string }} data
 * @returns Promise
 */
export function fetchWechatServicesSalesChatList(data) {
    return request({
        url: '/platform/wxkf/getGuideBuyerChatRecord',
        method: 'post',
        data
    })
}

/**
 * 修改客户昵称
 *
 * @export
 * @param {{buyerNickname:string,guideAccount:string,guideOpenId:string,openId:string}} data
 * @returns Promise
 */
export function fetchWechatServicesCustomerInfoUpdate(data) {
    return request({
        url: '/platform/wxkf/updateGuideBuyerRelation',
        method: 'post',
        data
    })
}

/**
 * 为客户更换顾问
 *
 * @export
 * @param {{newGuideAccount:string,newGuideOpenid:string,oldGuideAccount:string,oldGuideOpenid:string,openid:string}} data
 * @returns Promise
 */
export function fetchWechatServicesCustomerSalesUpdate(data) {
    return request({
        url: '/platform/wxkf/rebindGuideAcctForBuyer',
        method: 'post',
        data
    })
}

/**
 * 获取客户自定义参数
 *
 * @export
 * @param {{guideAccount:string,openId:string}} data
 * @returns Promise
 */
export function fetchWechatServicesDispalyTagGet(data) {
    return request({
        url: '/platform/wxkf/getGuideBuyerDisplayTag',
        method: 'post',
        data
    })
}
/**
 * 为客户设置自定义参数
 *
 * @export
 * @param {{displayTagList:[string],guideAccount:string,guideOpenId:string,openId:string}} data
 * @returns Promise
 */
export function fetchWechatServicesDispalyTagUpdate(data) {
    return request({
        url: '/platform/wxkf/addGuideBuyerDisplayTag',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/services/wechatServices.js